export default __webpack_public_path__ + "c982cc493c3a0c54793b3c585db344e3.png";